import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  settings: [],
  updateSuccess: false,
};

export const configurationSettingsSlice = createSlice({
  name: 'configurationSettings',
  initialState,
  reducers: {
    aGetConfigurationSettings: () => {},
    aGetConfigurationSettingsSuccess: (state, action) => {
      state.settings = action.payload.configurationSettings;
    },
    aGetConfigurationSettingsFail: () => {},
    aUpdateConfigSettings: (state) => {
      state.updateSuccess = false;
    },
    aUpdateConfigSettingsSuccess: (state, action) => {
      state.settings = action.payload.configurationSettings;
      state.updateSuccess = true;
    },
    aUpdateConfigSettingsFail: (state) => {
      state.updateSuccess = false;
    },
  },
});

export const {
  aGetConfigurationSettings,
  aGetConfigurationSettingsSuccess,
  aGetConfigurationSettingsFail,
  aUpdateConfigSettings,
  aUpdateConfigSettingsSuccess,
  aUpdateConfigSettingsFail
} = configurationSettingsSlice.actions;

export default configurationSettingsSlice.reducer;
